import React, { Component } from "react";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import "./RelatedContent.scss";
import MeetingTable from "../meetings/pages/meeting-tab/MeetingTable";
import { normalizeMeeting } from "../../../state/meetings/normalizers";
import { getMeetingUrl } from "../../../api/resources/meetings";
import { safeReferenceRequest } from "../../../api/safeReferenceRequest";

class RelatedMeetingContent extends Component {
  state = {
    fetchedMeetings: [],
  };

  async fetchRelatedMeetings() {
    const { relatedMeetings } = this.props;

    if (!relatedMeetings?.length) return;

    try {
      const rawResponses = await Promise.all(
        relatedMeetings.map((meeting) =>
          safeReferenceRequest(
            getMeetingUrl(meeting.uri, { tolerate401: true }),
            { uri: meeting.uri },
          ),
        ),
      );

      const responses = rawResponses
        .filter((response) => response?.status === 200 && !response.forbidden)
        .map((response) => normalizeMeeting(response.data));

      this.setState({
        fetchedMeetings: responses,
      });
    } catch (error) {
      console.error(error);
    }
  }

  async componentDidMount() {
    await this.fetchRelatedMeetings();
  }

  render() {
    const { t, relatedMeetings } = this.props;

    if (!relatedMeetings?.length) return null;

    return (
      <div className="related-content">
        <div className="group group--small group__flex detail__group group--underlined">
          <span className="headline-4 u-text-bold" id="documents">
            {t("references.document.relatedMeetings")}
          </span>
        </div>
        <MeetingTable meetings={this.state.fetchedMeetings} />
      </div>
    );
  }
}

// const mapProps = (state) => ({});

// const mapDispatchToProps = {};

export default compose(
  withTranslation("common"),
  // connect(mapProps, mapDispatchToProps),
)(RelatedMeetingContent);
